<section id="intro">
    <div class="container">
        <div class="row">
          <div class="col-lg-12 d-lg-flex flex-lg-column justify-content-center align-items-stretch pt-5 pt-lg-0 order-2 order-lg-1 aos-init aos-animate" data-aos="fade-up">
            <div>
              <h2>{{ data.CABECALHO.TITULO }}</h2>
              <h4>{{ data.CABECALHO.DESCRICAO }}</h4>
            </div>
          </div>
        </div>
      </div>
</section>

<section id="revenda">

    <div class="container">

        <div class="row d-flex justify-content-center">
            <div class="col-md-12">
                <h3 class="text-primary">{{ data.TITULO }}</h3>
                <hr>
            </div>
        </div>

        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">

            <div class="row d-flex justify-content-center">

                <div class="col-md-12">

                    <div class="row">
                        <div class="col-md-12">
                            <div class="control-group">
                                <div class="form-group mb-0 pb-2">
                                    <label class="control-label">{{ data.CAMPO_NOME }} <span class="text-danger">*</span></label>
                                    <input class="form-control form-control-sm" type="text" formControlName="formNome">

                                    <!-- Mensagens de erro -->
                                    <div *ngFor="let validator of data.VALIDATOR.NOME">
                                        <span class="text-danger"
                                            *ngIf="formGroup.get('formNome').hasError(validator.TYPE) && (formGroup.get('formNome').dirty || formGroup.get('formNome').touched) ">{{ validator.MENSAGEM }}</span>
                                    </div>
                                    <!-- Mensagens de erro -->

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-8">
                            <div class="control-group">
                                <div class="form-group mb-0 pb-2">
                                    <label class="control-label">{{ data.CAMPO_EMAIL }} <span class="text-danger">*</span></label>
                                    <input class="form-control form-control-sm" type="email"
                                        formControlName="formEmail">

                                    <!-- Mensagens de erro -->
                                    <div *ngFor="let validator of data.VALIDATOR.EMAIL">
                                        <span class="text-danger"
                                            *ngIf="formGroup.get('formEmail').hasError(validator.TYPE) && (formGroup.get('formEmail').dirty || formGroup.get('formEmail').touched) ">{{ validator.MENSAGEM }}</span>
                                    </div>
                                    <!-- Mensagens de erro -->

                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="control-group">
                                <div class="form-group mb-0 pb-2">
                                    <label class="control-label">{{ data.CAMPO_TELEFONE }} <span class="text-danger">*</span></label>
                                    <input class="form-control form-control-sm" type="text"
                                        formControlName="formTelefone" maxlength="18">

                                    <!-- mask="(99) 99999-9999" -->

                                    <!-- Mensagens de erro -->
                                    <div *ngFor="let validator of data.VALIDATOR.TELEFONE">
                                        <span class="text-danger"
                                            *ngIf="formGroup.get('formTelefone').hasError(validator.TYPE) && (formGroup.get('formTelefone').dirty || formGroup.get('formTelefone').touched) ">{{ validator.MENSAGEM }}</span>
                                    </div>
                                    <!-- Mensagens de erro -->

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-8">
                            <div class="control-group">
                                <div class="form-group mb-0 pb-2">
                                    <label class="control-label">{{ data.CAMPO_EMPRESA }} <span class="text-danger">*</span></label>
                                    <input class="form-control form-control-sm" type="text"
                                        formControlName="formEmpresa">

                                    <!-- Mensagens de erro -->
                                    <div *ngFor="let validator of data.VALIDATOR.EMPRESA">
                                        <span class="text-danger"
                                            *ngIf="formGroup.get('formEmpresa').hasError(validator.TYPE) && (formGroup.get('formEmpresa').dirty || formGroup.get('formEmpresa').touched) ">{{ validator.MENSAGEM }}</span>
                                    </div>
                                    <!-- Mensagens de erro -->

                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="control-group">
                                <div class="form-group mb-0 pb-2">
                                    <label class="control-label">{{ data.CAMPO_CARGO }}</label>
                                    <input class="form-control form-control-sm" type="text" formControlName="formCargo">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="control-group">
                                <div class="form-group mb-0 pb-2">
                                    <label class="control-label">{{ data.CAMPO_PAIS }} <span class="text-danger">*</span></label>
                                    <select class="form-control form-control-sm" formControlName="formPais">
                                        <option value="">
                                        <option *ngFor="let country of countrys" value="{{country.CODIGO}}">
                                            {{country.TITULO}}</option>
                                    </select>

                                    <!-- Mensagens de erro -->
                                    <div *ngFor="let validator of data.VALIDATOR.PAIS">
                                        <span class="text-danger"
                                            *ngIf="formGroup.get('formPais').hasError(validator.TYPE) && (formGroup.get('formPais').dirty || formGroup.get('formPais').touched) ">{{ validator.MENSAGEM }}</span>
                                    </div>
                                    <!-- Mensagens de erro -->

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-md-12">
                            <div class="control-group">
                                <div class="form-group mb-0 pb-2">
                                    <label class="control-label">{{ data.CAMPO_SOBRE_EMPRESA }} <span class="text-danger">*</span></label>
                                    <textarea class="form-control" rows="3"
                                        formControlName="formSobreEmpresa"></textarea>

                                    <!-- Mensagens de erro -->
                                    <div *ngFor="let validator of data.VALIDATOR.SOBRE_EMPRESA">
                                        <span class="text-danger"
                                            *ngIf="formGroup.get('formSobreEmpresa').hasError(validator.TYPE) && (formGroup.get('formSobreEmpresa').dirty || formGroup.get('formSobreEmpresa').touched) ">{{ validator.MENSAGEM }}</span>
                                    </div>
                                    <!-- Mensagens de erro -->

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="control-group">
                                <div class="form-group mb-0">
                                    <button class="btn btn-primary" type="submit"
                                        [disabled]="!formGroup.valid">{{ data.BOTAO }}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </form>

    </div>

</section>